import { FaTelegram, FaFacebook, FaLinkedin } from 'react-icons/fa';
import { StyledSocialIcons } from './styles/SocialIcons.style';

export default function SocialIcons() {
	return (
		<StyledSocialIcons>
			<li>
				<a href='https://www.facebook.com/safariictsolutionsplc'>
					<FaFacebook />
				</a>
			</li>
			<li>
				<a href='https://t.me/safariictsolutions'>
					<FaTelegram />
				</a>
			</li>
			<li>
				<a href='http://linkedin.com'>
					<FaLinkedin />
				</a>
			</li>
		</StyledSocialIcons>
	);
}
